import { ActiveSwitch, InactiveSwitch } from '../../../assets/icons';

const Switch = ({ status }) => {
  const Icon = status === 'Active' ? ActiveSwitch : InactiveSwitch;
  return <Icon />;
};
export default Switch;
